import React from 'react'
import {Button, Card, CardBody, CardImg, CardSubtitle, CardText, Col, Modal, ModalBody, Row} from "reactstrap";
import label from "enqc-utilities/src/label/Label"
import PropTypes from 'prop-types';
import ApplicationIcons from "enqc-utilities/src/misc/ApplicationIcons";
import {FaEye, MdClose} from 'react-icons/all';
import UserDetailPage from "../../pages/UserDetailPage";
import BaseComponent from "../BaseComponent";
import ModalCardHeader from "../Widget/ModalCardHeader";
import {isEmpty} from "../../utils/Utilities";

export default class UserDetailInformationModal extends BaseComponent{

    render() {
        let {user,show} = this.props
        let {manufacturingSite} = user
        if(!manufacturingSite){
            manufacturingSite= {}
        }

        return (
            <>
                {super.render()}
                <Modal
                    size="md"
                    centered={true}
                    isOpen={show}
                    onClosed={() => {}}>
                    <ModalCardHeader
                        content={
                            <span className="w-100 d-inline-block h3 text-center">{label.UserInformation}</span>
                        }/>
                    <ModalBody className="text-center">
                        <Row>
                            <Col>
                                <Row>
                                    <Col>
                                        <Card border="light" className="text-center p-0 mb-0">
                                            <div className="profile-cover rounded-top bg-light" />
                                            <CardBody className="pb-4">
                                                <CardImg
                                                    src={!isEmpty(user.photoUrl)?user.photoUrl:ApplicationIcons.Icons.userAvatar} alt={user.fullname}
                                                    style={{maxWidth:'70%'}}
                                                    className="bg-white border-secondary user-avatar large-avatar rounded-circle mx-auto mb-4" />
                                                <CardSubtitle><h4>{user.fullname}</h4></CardSubtitle>
                                                <CardText className="text-gray h5">{user.email} / {manufacturingSite.name}</CardText>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <br/>
                        <Row>
                            <Col>
                                <Button
                                    outline
                                    className="w-100 d-block btn-white-normal"
                                    color="light"
                                    onClick={()=>{
                                    this.props.onClose()
                                }}>
                                    <MdClose/>
                                    &nbsp;
                                    {label.Close}
                                </Button>
                            </Col>
                        </Row>
                        <br/>
                        <Row>
                            <Col>
                                <Button
                                    className="w-100 d-block btn-main"
                                    onClick={()=>{
                                        this.props.onClose()
                                        window.location.href = UserDetailPage.ENDPOINT+"?id="+user.id
                                    }}>
                                    <FaEye/>
                                    &nbsp;
                                    {label.Detail}
                                </Button>
                            </Col>
                        </Row>
                    </ModalBody>
                </Modal>
            </>
        );
    }

}
UserDetailInformationModal.propTypes = {
    user:PropTypes.object.isRequired,
    show:PropTypes.bool.isRequired,
    onClose:PropTypes.func.isRequired
}
